import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.5 7.5h-9V6h9z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.5 3V1.5H6V3h6V1.5h1.5V3h3v13.5h-15V3zM3 4.5V15h12V4.5z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M8.25 11.25V13.25h1.5V11.25h2V9.75h-2V7.75h-1.5v2H6.25v1.5z"
		})
	]
});
export default SvgCalendarPlus;
